import { z } from 'zod';

const DAT_EQUIPMENT_SEARCH_CHATS_STORAGE_KEY = 'dat-equipment-search-chats';
export const MAX_REMEMBERED_DAT_EQUIPMENT_SEARCH_CHATS = 50;

const ConversationIdsBySearchUrlSchema = z.record(z.string(), z.string());

function getStorageKey(organizationId: string) {
  return `${DAT_EQUIPMENT_SEARCH_CHATS_STORAGE_KEY}:${organizationId}`;
}

function readChats(organizationId: string): Record<string, string> {
  try {
    const value = window.localStorage.getItem(getStorageKey(organizationId));
    const parsed = ConversationIdsBySearchUrlSchema.safeParse(
      value ? JSON.parse(value) : {}
    );
    return parsed.success ? parsed.data : {};
  } catch {
    return {};
  }
}

export function getDatEquipmentSearchChat(
  organizationId: string,
  searchUrl: string
): string | null {
  return readChats(organizationId)[searchUrl] ?? null;
}

export function rememberDatEquipmentSearchChat(
  organizationId: string,
  searchUrl: string,
  conversationId: string
) {
  const chats = readChats(organizationId);
  delete chats[searchUrl];
  chats[searchUrl] = conversationId;
  const recentChats = Object.entries(chats).slice(
    -MAX_REMEMBERED_DAT_EQUIPMENT_SEARCH_CHATS
  );
  try {
    window.localStorage.setItem(
      getStorageKey(organizationId),
      JSON.stringify(Object.fromEntries(recentChats))
    );
  } catch {
    return;
  }
}
